import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import { useAuthStore } from './stores/auth';
import { useThemeStore } from './stores/theme';

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);

app.mount('#app');

// Initialize theme before anything else to prevent flash
const themeStore = useThemeStore();
themeStore.initTheme();

const authStore = useAuthStore();

authStore.init().then((authenticated) => {
  if (!authenticated && router.currentRoute.value.meta.requiresAuth !== false) {
    router.push({ name: 'login' });
  } else if (authenticated && router.currentRoute.value.name === 'login') {
    router.push({ name: 'builds' });
  }
});
